/* eslint-disable camelcase */
import programData from '@/constants/programs';
import { GENDER_NONE, GENDER_MALE, GENDER_FEMALE } from '@/constants/types';

export const WEEKDAYS = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

export default {
    formatWeekday(dateString) {
        const date = new Date(dateString);
        return WEEKDAYS[(date.getDay() + 6) % 7];
    },
    formatWeekdays(weekdays) {
        if (!Array.isArray(weekdays) || weekdays.length === 0) {
            return null;
        }

        const text = weekdays.map(md => WEEKDAYS[md % 7]).join('、');
        return `每${text}`;
    },
    formatDate(dateString) {
        const date = new Date(dateString);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const weekday = WEEKDAYS[(date.getDay() + 6) % 7];

        return `${month}月${day}日${weekday}`;
    },
    formatISODate(date) {
        function pad(number) {
            return `${number}`.padStart(2, '0');
        }

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());

        return `${year}-${month}-${day}`;
    },
    formatTime(timeString) {
        if (typeof timeString !== 'string') {
            return null;
        }
        return timeString.substr(0, 5);
    },
    formatGender(gender) {
        switch (gender) {
            case GENDER_MALE:
                return '男';
            case GENDER_FEMALE:
                return '女';
            case GENDER_NONE:
            default:
                return '未设置';
        }
    },
    formatProgramsOnly(programs) {
        const pTexts = programs.map((pid) => {
            const rp = programData.find(ip => ip.id === pid);
            if (!rp) {
                return null;
            }

            return rp.name;
        });

        return pTexts.filter(t => t).join('、');
    },
    formatProgramOptions(pid, program_options) {
        const rp = programData.find(ip => ip.id === pid);
        if (!rp) {
            return null;
        }

        if (rp.has_options && rp.id in program_options) {
            const options = program_options[rp.id];
            const optTexts = options.map((optId) => {
                const ropt = rp.options.find(iopt => iopt.id === optId);
                if (ropt) {
                    return ropt.name;
                }
                return null;
            });

            return optTexts.filter(ot => ot).join('、');
        } else if (rp.has_manual_options && rp.id in program_options) {
            return program_options[rp.id] || null;
        }

        return null;
    },
    formatPrograms({ programs, program_options }) {
        const pTexts = programs.map((pid) => {
            const rp = programData.find(ip => ip.id === pid);
            if (!rp) {
                return null;
            }

            let text = rp.name;
            if (rp.has_options && rp.id in program_options) {
                const options = program_options[rp.id];
                const optTexts = options.map((optId) => {
                    const ropt = rp.options.find(iopt => iopt.id === optId);
                    if (ropt) {
                        return ropt.name;
                    }
                    return null;
                });

                const optsText = optTexts.filter(ot => ot).join('、');
                if (optsText) {
                    text = `${text}（${optsText}）`;
                }
            } else if (rp.has_manual_options && rp.id in program_options) {
                const optText = program_options[rp.id];
                if (optText) {
                    text = `${text}（${optText}）`;
                }
            }

            return text;
        });

        return pTexts.filter(t => t).join('，');
    },
};



// WEBPACK FOOTER //
// ./src/utils/formatter.js